import Order from '@/api/order';

const common = {
  namespaced: true,

  state: {
    orderCount: {
      order_new: 0,
      order_commit: 0,
      order_ing: 0,
      order_success: 0,
      order_cancel: 0,
      order_refund: 0,
    },
  },

  getters: {},

  mutations: {
    saveOrderCount(state, orderCount) {
      state.orderCount = orderCount;
    },
  },

  actions: {
    loadOrderCount({ commit }) {
      Order.orderCount({}).then(res => {
        commit('saveOrderCount', res.data);
      });
    },
  },
};

export default common;
